function secondsToTime(seconds, needHours = true) {
  seconds = Math.max(0, Math.floor(+seconds))

  if (needHours) {
    const hours = Math.floor(seconds / 3600)
    const minutes = Math.floor(seconds / 60) % 60
    seconds = seconds % 60

    return [hours, minutes, seconds].map((n) => `${n}`.padStart(2, '00')).join(':')
  } else {
    const minutes = Math.floor(seconds / 60)
    seconds = seconds % 60

    return [minutes, seconds].map((n) => `${n}`.padStart(2, '00')).join(':')
  }
}

export { secondsToTime }
